module.exports = __webpack_public_path__ + "static/media/api_logo_cptblWith_strava_stack_white.712c61d4.svg";